import { PQR_RECEIVED_THROUGH_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { usePqrReceivedThroughList } from './hook';
import { PqrReceivedThroughListProps } from './props';

export const PqrReceivedThroughList = ({
    filters,
}: PqrReceivedThroughListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        usePqrReceivedThroughList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(
                    `${PQR_RECEIVED_THROUGH_DETAIL}/${item.id}`,
                    '_blank'
                )
            }
        />
    );
};
